import React from 'react';
import selectCamera from '../../../assets/images/camera-select.png';
import './style.css';

interface Props {
}

const SelectCameraComponent: React.FC<Props> = () => {
    return (
        <div className='w-100 h-100 flex al-it-c js-c pos-rel'>
            <img src={selectCamera}
                 alt="selectCamera"
                 className={'select-camera'}
                 draggable={false}
            />
        </div>
    )
};

export default SelectCameraComponent